/**
 * PrivacyPage — route wrapper at /privacy.
 * Renders full privacy policy from legal/privacy-copy.ts.
 * Public page — no gate required.
 */

import { PrivacyPolicyNext } from '../legal/privacy-copy'

export default function PrivacyPage() {
  return <PrivacyPolicyNext />
}
